module.exports = __webpack_public_path__ + "alex-35746eaaa88b08432341bf3352df6aed.png";